import * as jQuery from 'jquery';

export class Tabs {

  tabs: JQuery[];
  navItems: JQuery[] = [];
  tabItems: JQuery;
  activeTab: string;

  constructor(private elem: JQuery) {

    this.elem.hide();

    this.tabs = jQuery.makeArray(this.elem.find('[data-barker-tab]')).map((item) => jQuery(item));

    if (this.tabs.length === 0) { return; }

    const navWrap = jQuery('<div class="tabs">');

    const nav = jQuery('<ul/>');

    const tabWrap = jQuery('<div />');


    this.activeTab = this.tabs[0].data('barker-tab');

    this.navItems = this.tabs.map(
      (tab) => tab.data('barker-tab')
    ).map(
      (tabName) => jQuery('<li data-barker-tab="'+tabName+'"><a href="#">'+tabName+'</a></li>').on('click', (e) => this.handleClick(e, tabName))
    );

    this.elem.prepend(
      navWrap.prepend(
        nav.append(this.navItems)
      )
    );

    this.update();

    this.elem.show();

  }

  update() {

    this.navItems.map(
      item => [item, item.data('barker-tab')]
    ).forEach(
      ([item, tabName]) => (tabName === this.activeTab) ? item.addClass('is-active') : item.removeClass('is-active')
    );

    this.tabs.map(
      item => [item, item.data('barker-tab')]
    ).forEach(
      ([item, tabName]) => (tabName === this.activeTab) ? item.show() : item.hide()
    );

  }

  handleClick(e: JQuery.Event, tab: string) {

    e.preventDefault();

    this.activeTab = tab;

    this.update();

  }

}


// WEBPACK FOOTER //
// ./resources/src/components/tabs/tabs.tsx